module.exports = __webpack_public_path__ + "img/appltAliRGuide-3.c5857ca4.png";